import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'

import HTMLContent from 'components/common/HTMLContent'
import {
  DoubleQuotes1SVG,
  DoubleQuotes2SVG,
  DotsSVG,
} from 'components/common/SVGElements'
import { HideInMobileGrid } from 'components/common/Hidden'
import Multiline from './Multiline'
import VenderIntro from './VenderIntro'

const DoubleQuotes1 = styled(DoubleQuotes1SVG)`
  position: absolute;
  left: 0;
  top: 10px;
`
const DoubleQuotes2 = styled(DoubleQuotes2SVG)`
  position: absolute;
  right: 0;
  bottom: 10px;
`

const Company = ({ vender, containerId }) => {
  return (
    <>
      {!!vender?.introductionInfo?.venderIntroduction?.length && (
        <VenderIntro
          venderIntroduction={vender?.introductionInfo?.venderIntroduction}
          containerId={containerId}
        />
      )}
    </>
  )
}

export default Company
